import { createElementStyle } from "@/utility/style";
import type { ElementStyle } from "@mm/metx-workbench.meteomatics.com";

// Kept out of MapOverlay.tsx so overlays that only need this constant
// don't pull the whole map overlay module into their chunk.
export const DEFAULT_MAP_TITLE_STYLE: ElementStyle = createElementStyle({
  color: "#000000",
  fontSize: 14,
  fontWeight: 400,
  fontStyle: null,
  textDecoration: null,
});
